export const repeatScheduleHasChanged = (functionParameters={}) => {
    const { value } = functionParameters;
    window.repeatScheduleCurrentValue = value;

    console.log("window.repeatScheduleCurrentValue is ", window.repeatScheduleCurrentValue);

    return true;
};
